import { C8Node } from "csi/typings";

/** interface for item used to populate various components (i.e. select menu and possibly others in future) */
export interface ComponentItem<T = any> {
	/** indicates if this item is a custom one or one of store */
	customOption?: boolean;

	/** indicate whether or not disable this item */
	disabled?: boolean;

	/** group which would be used for grouping */
	group?: string;

	/** possible link if any */
	href?: string;

	/** string unique identifier */
	id: string;

	/** image source to be displayed (slim card) */
	imageSrc?: string;

	/** indicates if item (usually a selected one) is invalid - false by default */
	invalid?: boolean;

	/** indicate that given item is "No Results" */
	isEmptyGroupItem?: boolean;

	/** indicate that given item is group entry */
	isGroup?: boolean;

	/** name which would show up as the visual text */
	name?: string;

	/** name of second attribute (slim card) */
	name2?: string;

	/** if no name or res is provided, extract name directly from the node */
	node?: C8Node;

	/** pinyin code for the name */
	pinyinCode?: string;

	/** localization resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name").
	 *  Will only be used if no name provided.
	 */
	res?: string;

	/** parameters to pass if looking up resource */
	resParams?: Array<number | string>;

	/** raw value of item (i.e. URL if type is ref, number if type is double) */
	value?: T;
}

/** blank component item */
export const BLANK_COMPONENTITEM: ComponentItem = {
	id: "",
	name: "",
};